import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Hand, Search, Car, Calendar, PartyPopper, Lightbulb, ShieldCheck } from "lucide-react";

const ICONS = {
  greeting: Hand, finding: Search, driving: Car, events: Calendar,
  success: PartyPopper, thinking: Lightbulb, safety: ShieldCheck,
};

export const ThiriMascot = ({ state = "greeting", message, onAction, actionLabel }) => {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => setDismissed(false), [message]);
  if (dismissed || !message) return null;
  const Icon = ICONS[state] || Hand;
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        className="t-card flex items-start gap-3 p-4 relative overflow-hidden"
        data-testid="thiri-mascot"
      >
        <motion.div
          animate={{ y: [0, -4, 0] }}
          transition={{ repeat: Infinity, duration: 2.2, ease: "easeInOut" }}
          className="shrink-0 w-11 h-11 rounded-full bg-[#F9C31F] border-2 border-black/10 flex items-center justify-center"
        >
          <Icon className="w-5 h-5 text-[#12211C]" />
        </motion.div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-0.5">THIRI Companion</p>
          <p className="text-sm leading-relaxed">{message}</p>
          {onAction && (
            <button
              data-testid="mascot-action-btn"
              onClick={onAction}
              className="mt-2 text-xs font-bold text-primary hover:text-primary/70 transition-colors duration-200"
            >
              {actionLabel} →
            </button>
          )}
        </div>
        <button
          data-testid="mascot-dismiss-btn"
          onClick={() => setDismissed(true)}
          className="shrink-0 text-muted-foreground hover:text-foreground transition-colors duration-200"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </motion.div>
    </AnimatePresence>
  );
};
